import { render } from "./AddSlideButton.vue?vue&type=template&id=3c4f5e36"
import script from "./AddSlideButton.vue?vue&type=script&lang=js"
export * from "./AddSlideButton.vue?vue&type=script&lang=js"

import "./AddSlideButton.vue?vue&type=style&index=0&id=3c4f5e36&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__